import './script-loader';
import '../style/app.css';
import './modules/home'
import Navigation from './modules/navigation';
import Message from './modules/message';
import {REVIEWS} from './modules/reviews';
import appHtml from './app.html';
let app = () => {
    return {
        templateUrl: appHtml,
        controller: 'AppCtrl',
        controllerAs: 'app'
    }
};

class AppCtrl {
    constructor() {
        this.url = 'https://github.com/preboot/angular-webpack';
    }
}

const MODULE_NAME = 'app';

angular.module(MODULE_NAME, [Navigation.name, Message.name, REVIEWS], ['$interpolateProvider', function ($interpolateProvider) {
        $interpolateProvider.startSymbol('[[');
        $interpolateProvider.endSymbol(']]');
    }])
    .directive('app', app)
    .controller('AppCtrl', AppCtrl);

export default MODULE_NAME;


// WEBPACK FOOTER //
// ./src/app/app.js